module.exports = __webpack_public_path__ + "public/img/Keterampilan Berkomunikasi Dengan Pelanggan Untuk Kasir.a3073438.png";